import React from "react";

function ScoresVisibilityToggle({
  checked,
  label = "Show Results",
  tooltip = "Show or hide assessment results",
  onChange,
}) {
  return (
    <label className="eoy-scores-visibility-toggle">
      <span className="eoy-summary-toggle-label">{label}</span>
      <span className="eoy-summary-switch" data-tooltip={tooltip}>
        <input
          type="checkbox"
          aria-label={tooltip}
          checked={checked}
          onChange={(event) => onChange?.(event.target.checked)}
        />
        <span className="eoy-summary-slider" />
      </span>
    </label>
  );
}

export default ScoresVisibilityToggle;
